module.exports = __webpack_public_path__ + "img/pt_pt.fc56d2f6.png";